// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"edda3dc5","278":"68465d7f","399":"4241f5b2","610":"5df433c6","971":"96b78c28"}[chunkId] + ".chunk.js";
};